/* @flow */
import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import keys from '../../config/keys';
import app from './app';
import auth from './auth';
import news from './news';
import featured from './featured';
import featuredNews from './featuredNews';
import categories from './categories';
import worklists from './worklists';
import usages from './usages';
import productions from './productions';
import playerQueue from './playerQueue';
import trackSearch from './trackSearch';
import mediaSearch from './mediaSearch';
import media from './media';
import cart from './cart';
import smartlists from './smartlists';
import smartlist from './smartlist';
import onDemand from './onDemand';

const appPersistConfig = {
  key: 'app',
  storage: storage,
  whitelist: ['searchHistory'],
};

const cartPersistConfig = {
  key: 'cart',
  storage: storage,
  whitelist: ['cartItems', 'selectedComponentsByItem'],
};

const playerQueuePersistConfig = {
  key: 'playerQueue',
  storage: storage,
  whitelist: ['tracks'],
};

const worklistsPersistConfig = {
  key: 'worklists',
  storage: storage,
  whitelist: ['worklistItemsToCheckout'],
};

const reducers = {
  form,
  // $FlowFixMe
  app: keys.REDUX_PERSIST_ACTIVE ? persistReducer(appPersistConfig, app) : app,
  auth,
  categories,
  news,
  featured,
  featuredNews,
  worklists: keys.REDUX_PERSIST_ACTIVE
    ? // $FlowFixMe
      persistReducer(worklistsPersistConfig, worklists)
    : worklists,
  usages,
  productions,
  trackSearch,
  mediaSearch,
  media,
  playerQueue: keys.REDUX_PERSIST_ACTIVE
    ? // $FlowFixMe
      persistReducer(playerQueuePersistConfig, playerQueue)
    : playerQueue,
  // $FlowFixMe
  cart: keys.REDUX_PERSIST_ACTIVE ? persistReducer(cartPersistConfig, cart) : cart,
  smartlists,
  smartlist,
  onDemand,
};

export type Reducers = typeof reducers;

export default combineReducers(reducers);
